/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type ScheduleContainer_node$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventSummaryContainer_node$ref: FragmentReference;
export type EventSummaryContainer_node = {|
  +id: string,
  +user_event: ?{|
    +id: string,
    +notes: ?string,
    +referral_source: ?string,
    +$fragmentRefs: ScheduleContainer_node$ref,
  |},
  +user_contacts: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +id: ?string,
      +role: ?string,
      +node: ?{|
        +id: string,
        +first_name: ?string,
        +last_name: ?string,
        +company_name: ?string,
        +user_contact_addresses: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +line1: ?string,
              +line2: ?string,
              +city: ?string,
              +province: ?string,
              +postal_code: ?string,
              +country: ?string,
            |}
          |}>
        |},
        +user_contact_emails: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +address: ?string,
            |}
          |}>
        |},
        +user_contact_phones: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +label: ?string,
              +number: ?string,
            |}
          |}>
        |},
      |},
    |}>
  |},
  +$refType: EventSummaryContainer_node$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "count": null,
  "cursor": null,
  "direction": "forward",
  "path": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "EventSummaryContainer_node",
  "type": "Event",
  "metadata": {
    "connection": [
      v0,
      v0,
      v0,
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "user_contacts"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    v1,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user_event",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [
        v1,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "referral_source",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "ScheduleContainer_node",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "user_contacts",
      "name": "__EventSummaryContainer_user_contacts_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "EventUserContactConnectionWithRole",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "EventUserContactEdge",
          "plural": true,
          "selections": [
            v1,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "role",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContact",
              "plural": false,
              "selections": [
                v1,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "first_name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "last_name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": "user_contact_addresses",
                  "name": "__EventSummaryContainer_user_contact_addresses_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserContactAddressConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactAddressEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactAddress",
                          "plural": false,
                          "selections": [
                            v1,
                            v2,
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "line1",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "line2",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "city",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "province",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "postal_code",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "country",
                              "args": null,
                              "storageKey": null
                            },
                            v3
                          ]
                        },
                        v4
                      ]
                    },
                    v5
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": "user_contact_emails",
                  "name": "__EventSummaryContainer_user_contact_emails_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserContactEmailConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactEmailEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmail",
                          "plural": false,
                          "selections": [
                            v1,
                            v2,
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "address",
                              "args": null,
                              "storageKey": null
                            },
                            v3
                          ]
                        },
                        v4
                      ]
                    },
                    v5
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": "user_contact_phones",
                  "name": "__EventSummaryContainer_user_contact_phones_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserContactPhoneConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactPhoneEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactPhone",
                          "plural": false,
                          "selections": [
                            v1,
                            v2,
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "number",
                              "args": null,
                              "storageKey": null
                            },
                            v3
                          ]
                        },
                        v4
                      ]
                    },
                    v5
                  ]
                },
                v3
              ]
            },
            v4
          ]
        },
        v5
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '1c8b39f7ca8ff54d7dd2ce49f5f29b39';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/__generated__/EventSummaryContainer_node.graphql.js